import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import Button from '../../components/CustomButtons/Button';

//style
import imageUploadStyle from '../../components/CustomUpload/style/imageUploadStyle';

//assets
import { avatarPlaceholder } from '../../data';
import { convertBytesToMo } from '../../helpers/converts.js';

class ImageUpload extends React.Component {
  onChangeFile = async (event) => {
    if (!!this.props.limitFileSizeMo && !this.isFileSizeValid(event.target.files[0])) {
      this.props.handleError({
        status: 'danger',
        message: `Votre pièce jointe ne peut excéder ${this.props.limitFileSizeMo}Mo.`,
      });
      return;
    }
    this.props.handleChange(event);
  };

  isFileSizeValid = (file) => {
    const fileSizeMo = convertBytesToMo(file.size);
    return fileSizeMo < this.props.limitFileSizeMo;
  };

  render() {
    const {
      classes,
      size,
      fullWidth,
      labelText,
      uploadAccept,
      avatar,
      value,
      color,
      success,
      error,
      loading,
      customClass,
    } = this.props;

    const thumbnail = cx({
      [classes.thumbnail]: true,
      [classes.imgCircle]: avatar,
    });

    const image = value ? value : avatar ? avatarPlaceholder : null;
    const imagePreview = (avatar || value) && !loading && (
      <div className={thumbnail}>
        <img className={classes.thumbnailImg} src={image} alt='...' />
      </div>
    );

    const colorButton = error ? 'danger' : color;

    const circularProgress = <CircularProgress size={avatar ? 90 : 15} thickness={2} color='inherit' />;

    const addButton = (
      <div className={`${classes.addButtonWrapper} ${customClass}`}>
        <Button
          {...(size && { size: size })}
          fullWidth={fullWidth}
          color={colorButton}
          noBorder={loading}
          customClass={classes.addButton}>
          {loading ? circularProgress : labelText}
        </Button>
        <input
          type='file'
          accept={uploadAccept ? uploadAccept : 'image/*'}
          className={classes.input}
          onChange={this.onChangeFile}
        />
      </div>
    );

    const deleteButton = (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>Pièce jointe ajoutée</div>

        <Button color={colorButton} customClass={classes.deleteButton} onClick={this.props.handleRemove}>
          <i className={`fa fa-times`} />
        </Button>
      </div>
    );

    const containerStyle = cx({
      [classes.containerFullWidth]: fullWidth,
    });

    return (
      <div className={containerStyle}>
        {/* preview */}
        {imagePreview}

        {/* button */}
        {success ? deleteButton : addButton}
      </div>
    );
  }
}

ImageUpload.propTypes = {
  success: PropTypes.bool,
  loading: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg', 'xs', null]),
  fullWidth: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]).isRequired,
  value: PropTypes.string,
  avatar: PropTypes.bool,
  round: PropTypes.bool,
  color: PropTypes.string,
  customClass: PropTypes.string,
  uploadAccept: PropTypes.string,
  handleChange: PropTypes.func,
  handleRemove: PropTypes.func,
  limitFileSizeMo: PropTypes.number,
  handleError: PropTypes.func,
};

ImageUpload.defaultProps = {
  fullWidth: false,
  customClass: '',
};

export default withStyles(imageUploadStyle)(ImageUpload);
